import { Icon } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '~/components/Loader';
import Modal from '~/components/Modal';
import {
  useDeleteAllFavoritesMutation,
  useDeleteAllNotesMutation,
} from '~/redux/api/userApiSlice';
import { closeModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';
import { clearUserFavorites } from '~/utils/favorites';

const DeleteFavoritesModal = ({
  setListings,
  setNotesCount,
  setFavoritesCount,
}: {
  setListings: React.Dispatch<React.SetStateAction<any[]>>;
  setNotesCount: React.Dispatch<React.SetStateAction<number>>;
  setFavoritesCount: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation('app');
  const dispatch = useAppDispatch();
  const [deleteAllFavorites, { isLoading: isLoadingDeleteFavorites }] =
    useDeleteAllFavoritesMutation();
  const [deleteAllNotes, { isLoading: isLoadingDeleteNotes }] =
    useDeleteAllNotesMutation();

  const isLoading = isLoadingDeleteFavorites || isLoadingDeleteNotes;

  const handleDeleteFavorites = async () => {
    const [res] = await Promise.all([
      deleteAllFavorites(null),
      deleteAllNotes(null),
    ]);
    if ('data' in res) {
      clearUserFavorites();
      setListings([]);
      setFavoritesCount(0);
      setNotesCount(0);
      dispatch(closeModal('deleteFavorite'));
    }
  };

  return (
    <Modal modalKey="deleteFavorite" title={t('deleteFavoriteTitle')}>
      <div className="flex flex-col gap-3x w-full pb-3x">
        <div className="flex flex-col gap-1.5x">
          <p className="text-title-4 text-gray__dark_2">
            {t('deleteFavoriteConfirm')}
          </p>
        </div>
        <div className="flex justify-between gap-1.5x">
          <button
            onClick={handleDeleteFavorites}
            className="w-full !bg-gray_light_1 no-underline hover:no-underline element-center rounded-[26px] text-red_dark h-[40px]"
          >
            {isLoading ? (
              <Loader size="small" />
            ) : (
              <>
                <Icon name="trash" size="16px" />
                <p className="text-link">{t('delete')}</p>
              </>
            )}
          </button>
          <button
            onClick={() => dispatch(closeModal('deleteFavorite'))}
            className="w-full !bg-gray_light_1 no-underline hover:no-underline element-center gap-0.5x rounded-[26px] text-blue h-[40px]"
          >
            <p className="text-link">{t('cancel')}</p>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteFavoritesModal;
